import type { PaletteOptions } from '@mui/material/styles';

export const BRAND_COLORS = {
  primary: '#B54191',
  secondary: '#53647B',
  dark: '#000000',
  white: '#FFFFFF',
} as const;

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: BRAND_COLORS.primary,
    contrastText: BRAND_COLORS.white,
  },
  secondary: {
    main: BRAND_COLORS.secondary,
    contrastText: BRAND_COLORS.white,
  },
  background: {
    default: '#F5F6F8',
    paper: BRAND_COLORS.white,
  },
  text: {
    primary: BRAND_COLORS.dark,
    secondary: BRAND_COLORS.secondary,
  },
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: BRAND_COLORS.primary,
    contrastText: BRAND_COLORS.white,
  },
  secondary: {
    main: BRAND_COLORS.secondary,
    contrastText: BRAND_COLORS.white,
  },
  background: {
    default: '#121212',
    paper: '#1E1E1E',
  },
  text: {
    primary: BRAND_COLORS.white,
    secondary: '#B0B7C3',
  },
};
